;(function () {
  window.curatorToggle = function (scope) {
    var toggleField
    toggleField = function (field, state) {
      var input
      input = $(field).find("input.select")
      if (!state) {
        input.attr("name", input.attr("name").replace(/^disabled_/, ""))
      } else {
        input.attr("name", "disabled_" + input.attr("name"))
        input.val("")
        input.closest(".dropdown").dropdown("clear")
      }
      return $(field).toggleClass("hide", state)
    }
    $(scope)
      .find("#uploaded_file_owner_type_, #folder_owner_type_")
      .change(function () {
        toggleField(
          $(scope).find(".member-curator-select"),
          $(this).is(":checked")
        )
        return toggleField(
          $(scope).find(".group-curator-select"),
          $(this).is(":checked")
        )
      })
    $(scope)
      .find("#uploaded_file_owner_type_group, #folder_owner_type_group")
      .change(function () {
        toggleField(
          $(scope).find(".member-curator-select"),
          $(this).is(":checked")
        )
        return toggleField(
          $(scope).find(".group-curator-select"),
          !$(this).is(":checked")
        )
      })
    $(scope)
      .find(
        "#uploaded_file_owner_type_clubrecord, #folder_owner_type_clubrecord"
      )
      .change(function () {
        toggleField(
          $(scope).find(".member-curator-select"),
          !$(this).is(":checked")
        )
        return toggleField(
          $(scope).find(".group-curator-select"),
          $(this).is(":checked")
        )
      })
    $(scope)
      .find(
        "#uploaded_file_owner_type_group, #uploaded_file_owner_type_clubrecord, #uploaded_file_owner_type_"
      )
      .filter(":checked")
      .trigger("change")
    return $(scope)
      .find(
        "#folder_file_owner_type_group, #folder_owner_type_clubrecord, #folderoaded_file_owner_type_"
      )
      .filter(":checked")
      .trigger("change")
  }
}).call(this)
